module.exports = __webpack_public_path__ + "img/public/AdminIcons/adminReviews.svg?1e7d7d0c";